import { createSlice } from '@reduxjs/toolkit';

interface LoadingState {
  requestsInFlight: number;
}

const initialState: LoadingState = {
  requestsInFlight: 0,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading(state) {
      state.requestsInFlight += 1;
    },
    finishLoading(state) {
      state.requestsInFlight = Math.max(0, state.requestsInFlight - 1);
    },
    resetLoading(state) {
      state.requestsInFlight = 0;
    },
  },
});

export const { startLoading, finishLoading, resetLoading } = loadingSlice.actions;
export default loadingSlice.reducer;


